import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useGlobalContext } from "../../../../../Context/Context";
import Button from "../../../../Custom/Button/Button";
import backImg from "../../../../../picture/Back.png";
import DokumentaKolektivnaOpremaArhivirana from "./DokumentaKolektivnaOpremaArhivirana";
import DokumentaKolektivnaOpremaVazeca from "./DokumentaKolektivnaOpremaVazeca";

function PreviewKolektivnaOprema({ sredstvoId, setSredstvoId }) {
  const [vazecaDokumenta, setVazecaDokumenta] = useState([]);
  const [arhiviranaDokumenta, setArhiviranaDokumenta] = useState([]);
  const [loading, setLoading] = useState(false);

  const { baseUrl, apiKey, loggedUser } = useGlobalContext();

  // 1. Definišemo fetch funkciju na vrhu da bi bila dostupna svuda
  const fetchDokumenta = useCallback(async () => {
    if (!sredstvoId || !loggedUser) return;
    setLoading(true);
    try {
      const payload = {
        user_id: loggedUser.id,
        api_key: apiKey,
        masina_id: sredstvoId
      };

      const { data } = await axios.post(
        `${baseUrl}/machines/read_documents.php`,
        payload
      );

      if (data.status === 200) {
        setVazecaDokumenta(data.vazeca || []);
        setArhiviranaDokumenta(data.arhivirana || []);
      }
    } catch (error) {
      console.error("Greška pri učitavanju dokumenata:", error);
    } finally {
      setLoading(false);
    }
  }, [sredstvoId, baseUrl, apiKey, loggedUser]);

  // 2. Inicijalno učitavanje kada se promeni sredstvoId
  useEffect(() => {
    fetchDokumenta();
  }, [fetchDokumenta]);

  // 3. Slušanje signala iz tabela (Niš signal) za automatsko osvežavanje prikaza
  useEffect(() => {
    const handleRefresh = () => {
      console.log("Signal primljen: Osvežavam liste...");
      fetchDokumenta();
    };
    window.addEventListener("machineAdded", handleRefresh);
    return () => window.removeEventListener("machineAdded", handleRefresh);
  }, [fetchDokumenta]);

  const handleBack = () => {
    setSredstvoId("");
  };

  const moveToArhivirani = async (item) => {
    const nazivDokumenta = item.naziv || "dokument";
    if (
      !window.confirm(
        `Da li ste sigurni da želite da arhivirate: ${nazivDokumenta}?`
      )
    )
      return;

    const formData = new FormData();
    formData.append("document_id", item.id);
    formData.append("user_id", loggedUser.id);
    formData.append("api_key", apiKey);

    try {
      const { data } = await axios.post(
        `${baseUrl}/machines/archive_document.php`,
        formData
      );
      if (data.status === 200) {
        // Okidamo signal koji smo gore definisali u useEffect-u
        window.dispatchEvent(new Event("machineAdded"));
      } else {
        alert("Greška sa servera: " + data.message);
      }
    } catch (error) {
      console.error("Greška pri arhiviranju:", error);
    }
  };

  const moveToVazeci = async (item) => {
    if (
      !window.confirm(
        `Vratiti dokument iz arhive: ${item.naziv || "dokument"}?`
      )
    )
      return;

    const formData = new FormData();
    formData.append("document_id", item.id);
    formData.append("user_id", loggedUser.id);
    formData.append("api_key", apiKey);

    try {
      const { data } = await axios.post(
        `${baseUrl}/machines/restore_document.php`,
        formData
      );
      if (data.status === 200) {
        // Okidamo signal koji osvežava obe tabele odmah
        window.dispatchEvent(new Event("machineAdded"));
      }
    } catch (error) {
      console.error("Greška pri vraćanju iz arhive:", error);
    }
  };

  if (
    loading &&
    vazecaDokumenta.length === 0 &&
    arhiviranaDokumenta.length === 0
  )
    return <div style={{ padding: "20px" }}>Učitavanje dokumenata...</div>;

  return (
    <div>
      <div onClick={handleBack} style={{ width: "100px", height: "50px" }}>
        <Button activation={true}>
          <img src={backImg} alt="back" />
        </Button>
      </div>

      <div style={{ overflowY: "auto", height: "420px", marginTop: "20px" }}>
        {/* TABELA VAŽEĆIH */}
        <DokumentaKolektivnaOpremaVazeca
          dokumenta={vazecaDokumenta}
          moveToArhivirani={moveToArhivirani}
        />

        {/* TABELA ARHIVIRANIH */}
        <div style={{ marginTop: "20px" }}>
          <DokumentaKolektivnaOpremaArhivirana
            dokumenta={arhiviranaDokumenta}
            setDokumenta={setArhiviranaDokumenta}
            moveToVazeci={moveToVazeci}
          />
        </div>
      </div>
    </div>
  );
}


export default PreviewKolektivnaOprema;
